import { ApolloError } from "@apollo/client";

const getGraphqlErrorMessage = (graphqlErrors: any) => {
  const errorMessages: any = [];
  graphqlErrors.forEach((error: any) => {
    if (error.extensions.code === "OUTPAVE_CUSTOM_ERROR") {
      errorMessages.push(error.message);
    } else {
      errorMessages.push("Something went wrong!");
    }
  });
  return errorMessages.length > 0 ? errorMessages.join("\n") : "";
};

// An error the server worded for the user to read, such as a refusal, rather than a failure it hid
const isUserFacingError = (error: unknown): error is ApolloError =>
  error instanceof ApolloError &&
  error.graphQLErrors.some(
    (each) => each.extensions?.code === "OUTPAVE_CUSTOM_ERROR",
  );

// The server's own wording for an error it meant the user to read, else the caller's fallback
const getUserFacingErrorMessage = (error: unknown, fallback: string) =>
  isUserFacingError(error)
    ? getGraphqlErrorMessage(error.graphQLErrors)
    : fallback;

export { getGraphqlErrorMessage, getUserFacingErrorMessage, isUserFacingError };
